// LAP-550 — Card Répartition : donut + légende lisible
import { Box, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined'
import CardHeader from '../../_shared/CardHeader'
import EmptyState from '../../_shared/EmptyState'
import { formatMoney } from '../../_shared/gridCols'

const PALETTE = [
  '#63a0ff', '#a78bfa', '#22d3ee', '#34d399',
  '#f59e0b', '#f472b6', '#f97316', '#60a5fa',
  '#c084fc', '#fbbf24', '#38bdf8', '#94a3b8',
]

export default function RepartitionInvestments({ report }) {
  const { t, i18n } = useTranslation('layout')
  const [revData, setRevData] = useState({
    labels: [
      t('investments.portfolio.repartition.defaults.salary'),
      t('investments.portfolio.repartition.defaults.passive'),
      t('investments.portfolio.repartition.defaults.other'),
    ],
    datasets: [
      {
        data: [80, 5, 15],
        backgroundColor: PALETTE.slice(0, 3),
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 2,
        hoverOffset: 6,
        precision: 0,
      },
    ],
  })
  useEffect(() => {
    setRevData({
      labels: report?.labels,
      datasets: [
        {
          data: report?.data,
          backgroundColor: PALETTE,
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          hoverOffset: 6,
          precision: 0,
        },
      ],
    })
  }, [report, t, i18n.language])

  const optiondonut = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    clip: true,
    cutout: '72%',
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          // Les données du dataset sont des MONTANTS (€) : on affiche la part
          // réelle de l'allocation (x/total), pas le montant suffixé « % ».
          const ds = ctx.chart.data.datasets[0]?.data || []
          const total = ds.reduce((a, b) => a + (Number(b) || 0), 0)
          const pct = total > 0 ? ((Number(value) || 0) / total) * 100 : 0
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + pct.toFixed(1) + ' %'
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
        font: { size: 11, weight: 600 },
      },
      legend: { display: false, events: [] },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon={<PieChartOutlineOutlinedIcon fontSize="small" />}
        title={t('investments.portfolio.repartition.title')}
        subtitle={t('investments.portfolio.repartition.subtitle')}
        value={report?.total !== undefined ? formatMoney(report?.total) : null}
      />
      {/* flex:1 + minHeight:0 : le donut (maintainAspectRatio:false) tient dans
          la card avec sa légende, sans déborder. */}
      <Box mt={2} flex={1} minHeight={0} py={1} display="flex" flexDirection="column">
        {report?.labels?.length > 0 ? (
          <>
            <Box flex={1} minHeight={0} position="relative">
              <Doughnut data={revData} options={optiondonut} />
            </Box>
            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent="center"
              spacing={1.5}
              sx={{ mt: 1.5, rowGap: 0.5, '& > *': { fontSize: 11 } }}
            >
              {report.labels.map((lab, i) => (
                <Box key={i} display="flex" alignItems="center" sx={{ color: 'rgba(255,255,255,0.7)', mr: 1.5 }}>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: PALETTE[i % PALETTE.length],
                      mr: 0.75,
                    }}
                  />
                  {lab}
                </Box>
              ))}
            </Stack>
          </>
        ) : (
          <EmptyState label={t('investments.portfolio.noInvestmentsYet')} />
        )}
      </Box>
    </Box>
  )
}
